import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import axios from 'axios';
import router from '@/router';
import store from '@/store';
import constants from '@/constants';

declare global {
    interface Window { appInsights: ApplicationInsights; }
}

export default {
    initializeAppInsights() {
        axios.get<string>('/api/Settings/InstrumentationKey').then((response) => {
            const appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: response.data,
                    distributedTracingMode: DistributedTracingModes.W3C,
                    enableAutoRouteTracking: true,
                }
            });

            appInsights.loadAppInsights();
            window.appInsights = appInsights;

            router.app.$watch(constants.LocationParamPath, (newLocation) => {
                this.setUserContext(store.state.userModule.user.userName, newLocation);
            });

            store.watch(state => state.userModule.user.userName, updatedName => {
                this.setUserContext(updatedName, router.currentRoute.params.location);
            });

            this.setUserContext(store.state.userModule.user.userName, router.currentRoute.params.location);
        });
    },
    setUserContext(userName: string | undefined, location: string | undefined) {
        userName = userName || '';
        location = location || '';

        const regex = /[,;=| ]+/g;
        userName = userName.replace(regex, '_');
        location = location.replace(regex, '_');

        window.appInsights.setAuthenticatedUserContext(userName, location);
    }
};
